export type MenuItemId =
  | 'start'
  | 'continue'
  | 'survival'
  | 'boss-rush'
  | 'score-attack'
  | 'gallery'
  | 'coop'
  | 'options'
  | 'credits'
  | 'resume'
  | 'restart'
  | 'quit-to-title'
  | 'opt-master'
  | 'opt-mute'
  | 'opt-music'
  | 'opt-sfx'
  | 'opt-voice'
  | 'opt-blood'
  | 'opt-shake'
  | 'opt-language'
  | 'opt-key-remap'
  | 'opt-gamepad-remap'
  | 'opt-back'
  | 'mode-campaign'
  | 'mode-boss-rush'
  | 'mode-score-attack'
  | 'mode-survival'
  | 'mode-back';

export interface MenuItem {
  readonly id: MenuItemId;
  readonly label: string;
  readonly enabled: boolean;
}

/**
 * Pure (no Phaser) navigation cursor for a vertical menu.
 * Skips disabled items on move; confirm() returns null for disabled selections.
 */
export class MenuNavigation {
  private readonly _items: MenuItem[];
  private _index: number;

  constructor(items: MenuItem[]) {
    this._items = items;
    const first = items.findIndex((item) => item.enabled);
    this._index = first === -1 ? 0 : first;
  }

  get index(): number {
    return this._index;
  }

  get current(): MenuItem {
    return this._items[this._index];
  }

  get items(): readonly MenuItem[] {
    return this._items;
  }

  moveUp(): void {
    for (let i = this._index - 1; i >= 0; i--) {
      if (this._items[i].enabled) {
        this._index = i;
        return;
      }
    }
  }

  moveDown(): void {
    for (let i = this._index + 1; i < this._items.length; i++) {
      if (this._items[i].enabled) {
        this._index = i;
        return;
      }
    }
  }

  confirm(): MenuItemId | null {
    const item = this._items[this._index];
    return item.enabled ? item.id : null;
  }
}
